import React, { useEffect, useState } from 'react';

import { apiCall } from '../api';

const Updates = ({ title, app }) => {

    const [currentUpdates, setCurrentUpdates] = useState([]);
    const [newUpdate, setNewUpdate] = useState('');
    const [newAuthor, setNewAuthor] = useState('');

    const [refresh, setRefresh] = useState(false);

    const fontClass = app === 'mikey' ? 'mikey' : 'ella';


    useEffect(() => {

        const getUpdates = async () => {

            const [success, resp] = await apiCall({
                method: 'get',
                url: '/mikeyandeleanor/api/updates/',
                params: {
                    app: app
                }
            });

            if (success) setCurrentUpdates(resp);
            
        };

        getUpdates();


    }, [refresh]);

    const handleSubmitUpdate = async () => {
            
            const [success, resp] = await apiCall({
                method: 'post',
                url: '/mikeyandeleanor/updates/submit_update/',
                data: {
                    app: app,
                    message: newUpdate,
                    author: newAuthor
                }
            });

            setNewAuthor('');
            setNewUpdate('');
            setRefresh(!refresh);
        };

    const formatDate = (date) => {

        const dateObj = new Date(date);

        return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
    }


    const renderUpdates = () => {

        if (currentUpdates.length === 0) {
            return;
        }

        return currentUpdates.map((update, index) => {
                
                return (
                    <div
                    key={index}
                    className='update-post'
                    >
                        <div>
                            {update.message}
                        </div>
                        <div
                        style={{
                            textAlign: 'right',
                        }}>
                            {`- ${update.author} - ${formatDate(update.date_added)}`}
                        </div>
                    
                    </div>
                )
    
            }
        );
    }


    return (

        <div
        className='updates-container'
        >

            <div
            className={`updates-title ${fontClass}`}>
                {title}
            </div>

            <div 
            className='updates-content'>
                { renderUpdates() }
            </div>

            <div
            className='updates-post'>

                <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                }}>
                    <input
                    className='update-input'
                    placeholder='Write a new update...'
                    onChange={(e) => setNewUpdate(e.target.value)}
                    />
                    <input
                    className='author-input'
                    placeholder='Author'
                    onChange={(e) => setNewAuthor(e.target.value)}
                />


                </div>

                
                <button
                className='update-button'
                onClick={() => handleSubmitUpdate()}   
                >
                    Post
                </button>
                


            </div>





        </div>
    )


};

export default Updates;